export default __webpack_public_path__ + "static/media/Luogo_accogliente.6d208f57.jpg";